import React, { useEffect, useState } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css"; 
import "../../App.css";

function RangeDatePicker({ selectedDate, setSelectedDate }) {
    const [range, setRange] = useState([
        {
            startDate: selectedDate.startDate,
            endDate: selectedDate.endDate,
            key: "selection",
        },
    ]);

    const [showPicker, setShowPicker] = useState(false);
    const togglePicker = () => setShowPicker(!showPicker);

    const formatDate = (date) => {
        return date.toLocaleDateString("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    useEffect(() => {
        const newStartDate = range[0].startDate;
        const newEndDate = range[0].endDate;
        if (
            newStartDate.getTime() !== selectedDate.startDate.getTime() ||
            newEndDate.getTime() !== selectedDate.endDate.getTime()
        ) {
            setSelectedDate({
                startDate: newStartDate,
                endDate: newEndDate,
            });
        }
    }, [range,selectedDate,setSelectedDate]);
    return (
        <>
         <div style={{ position: "relative", display: "inline-block" }}>
            {/* Button dengan label range */}
            <button
                onClick={togglePicker}
                style={{
                    padding: "10px 20px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    background: "#fff",
                    cursor: "pointer",
                    textAlign: "left",
                }}
            >
                {`${formatDate(range[0].startDate)} - ${formatDate(range[0].endDate)}`}
            </button>

            {/* Date range picker */}
            {showPicker && (
                <div
                    className="date-range-container"
                    style={{
                        position: "absolute",
                        top: "100%",
                        right: 0, 
                        zIndex: 10
                    }}
                >
                    <DateRangePicker
                        ranges={range}
                        editableDateInputs={true}
                        onChange={(item) => setRange([item.selection])}
                        moveRangeOnFirstSelection={false}
                        months={1}
                        direction="horizontal"
                        rangeColors={["#00b2ff"]}
                        showDateDisplay={false}
                    />
                    <div style={{ textAlign: "right", padding: "10px",backgroundColor: "#ffffff" }}>
                        <button
                            onClick={() => setShowPicker(false)}
                            style={{
                                padding: "5px 10px",
                                border: "none",
                                borderRadius: "3px",
                                background: "#00b2ff",
                                color: "#fff",
                                cursor: "pointer",
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
        </>
    )
}

export default RangeDatePicker